package com.ijoin.ui.util

import com.ijoin.data.api.ApiClient

/**
 * Convert API-relative media path to a thumbnail path with given width.
 * Input examples:
 *  - /api/media/events/<folder>/photos/photos-1.jpg -> /api/media/events/<folder>/photos/thumbs/600/photos-1.jpg
 * If the path doesn't match expected pattern, returns original.
 */
fun toThumbUrl(apiRelativePath: String, width: Int): String {
    if (!apiRelativePath.startsWith("/api/media/")) return apiRelativePath
    // Expect segments: /api/media/events/{folder}/{type}/{file}
    val parts = apiRelativePath.split('/')
    // indices: 0:"", 1:"api", 2:"media", 3:"events", 4:folder, 5:type, 6+:file parts
    if (parts.size < 7) return apiRelativePath
    if (parts[3] != "events") return apiRelativePath
    val type = parts[5]
    // Only generate thumbnails for photo/image types
    if (type != "photos" && type != "photos-mobile" && type != "images") return apiRelativePath
    val before = parts.subList(0, 6).joinToString("/") // up to type
    val after = parts.subList(6, parts.size).joinToString("/") // filename
    return "$before/thumbs/$width/$after"
}

/**
 * Resolves relative media paths ("/api/media/...") to absolute URLs so Coil can fetch them.
 */
fun resolveMediaUrl(path: String?): String? {
    if (path.isNullOrBlank()) return null
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path
    }
    if (path.startsWith("data:")) {
        return path
    }
    val normalized = if (path.startsWith("/")) path else "/$path"
    return ApiClient.getBaseUrl() + normalized
}
